import { errorHandler } from 'Modules'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import { Deserialize } from 'cerialize'
import { RequestParams, ResponseCatalog } from 'Models'
import { unionBy } from 'lodash'
import {
	sberGeoAddressNS,
	sberGeoAddressSlice,
	sberGeoAddress,
	sberGeoAddressApi,
} from 'Pages/registratorCabinet'
import { SberGeoUnitModel } from 'Pages/orders_design'

export function* getSberGeoAddress(action: sberGeoAddressNS.getSberGeoAddress) {
	try {
		const { params, options } = action.payload
		let paramsForRequest: RequestParams
		if (params) {
			paramsForRequest = params
		} else {
			paramsForRequest = yield* select(sberGeoAddress.getParams)
		}
		const res = yield* call(sberGeoAddressApi.getItems, paramsForRequest)
		const sberGeoList = new ResponseCatalog<SberGeoUnitModel>(res)
		sberGeoList.entries = res.entries.map((region) => Deserialize(region, SberGeoUnitModel))
		if (options?.loadMore || options?.searchMissing) {
			const oldUnits = yield* select(sberGeoAddress.getItems)
			sberGeoList.entries = options?.searchMissing
				? sberGeoList.entries.concat(sberGeoList.entries)
				: unionBy(oldUnits.entries, sberGeoList.entries, 'id')
			if (options?.searchMissing) sberGeoList.total_entries = oldUnits.total_entries
		}
		yield* put(sberGeoAddressSlice.actions.setSberGeoAddress(sberGeoList))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* sberGeoAddressSaga() {
	yield* takeLatest(sberGeoAddressSlice.actions.getSberGeoAddress, getSberGeoAddress)
}
